import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import MacleJSBridge from 'src/bridges';

export interface NavigateBackOption extends Partial<GeneralInvokeOption> {
  delta: number;
}

/**
 * ```js
 *   ma.miniProgram.navigateTo({
 *     delta: 1,
 *     success: function(res) {},
 *     fail: function(res) {},
 *     complete: function(res) {},
 *   })
 * ```
 */
export function navigateBack(option: NavigateBackOption): void {
  const fixedOption = Object.assign({ delta: 1 }, option);
  MacleJSBridge.beforeInvoke(APINames.MiniProgram.NAVIGATE_BACK, fixedOption);
}
